export default {
	open: 'Open',
	remove: 'Remove',

	illustration: 'Illustration',

	error: 'Error',
	'error/token error': 'Token validation error.',

	'general/floor': '{{floor}} floor',
	'general/floor_abbr': '{{floor}}.flr',
	'general/toggle/yes': 'Yes',
	'general/toggle/no': 'No',

	'colors/transparent': 'Transparent',
	'colors/white': 'White',
	'colors/green': 'Green',
	'colors/blue': 'Blue',
	'colors/greyWithWhite': 'Grey/white',
	'colors/greyWithBlack': 'Grey/black',
	'colors/dark': 'Dark',
	'colors/lightBlue': 'Light blue',
	'colors/yellow': 'Yellow',
	'colors/orange': 'Orange',

	'page/layout_large-and-small--small-on-left': 'Small image on left',

	collection: 'Collection',
	'collection/Save': 'Save',
	'collection/Confirm remove': 'Are you sure you want to remove the collection?\n\nAttention: Collection will be available through the collection url even after the deletion.',
	'colleciton/New collection': 'Uusi kokoelma',
	'collection/Collections': 'Collections',
	'collection/Brochure': 'Contains one brochure',
	'collection/Brochure_plural': 'Contains {{count}} brochures',
	'collection/Missing brochures': 'One or more of selected brochures have been removed',
	'collection/Add to collection': 'Add to collection',
	'collection/Remove from collection': 'Remove from collection',
	'collection/Add master to collection': 'Add master to collection',
	'collection/Remove master from collection': 'Remove master from collection',
	'collection/Brochures': 'Brochures',
	'collection/Recipients': 'Recipients',
	'collection/Recipient/Remove': 'Remove',
	'collection/Recipient/Add new recipient': 'Add new recipient',
	'collection/Collection': 'Form',
	'collection/Collection name': 'Collection name',
	'collection/Name': 'Name',
	'collection/Name/Placeholder': 'Firstname Lastname',
	'collection/Email': 'Email',
	'collection/Email/Placeholder': 'client@client.fi',
	'collection/Message': 'Message',
	'collection/Message/Placeholder': 'Message to be sent with collection...',
	'collection/Signature': 'Signature',
	'collection/Signature/Placeholder': 'Signature to be sent with collection',
	'collection/Cc': 'Send me a copy of the message',
	'collection/Start a new collection': 'Create a new collection',
	'collection/Start a new collection/Confirm': 'Are you sure you want to createe a new collection?',
	'collection/Sending': 'Sending...',
	'collection/Send': 'Send',
	'collection/Send/Confirm': 'Collection sent successfully!\n\nDo you want to start a new collection?',

	'contacts/Your contacts': 'Your contacts',
	'contacts/Your contact': 'Your contact',
	'contacts/Your contacts/Customer service': 'Sponda’s Customer Service Center +358 20 355 6677 Mon-Fri at 8.30–16 | sponda.fi',
	'contacts/Your contacts/body': 'SPONDA Ltd. is one of the largest property investment companies in Finland. We own, lease and develop office and retail properties and shopping centres in the largest cities in Finland. We are a forerunner in property investment, an experienced property developer and a responsible urban developer. Our properties are situated in the best city locations with good connections. We create modern and functional spaces, that accommodate new ways of working. Our mission is to develop operating environments that promote the success of our customers.',
	'contacts/Why sponda': 'Why choose Sponda as your property partner',
	'contacts/Why sponda/1/title': 'OUR EXTENSIVE PROPERTY PORTFOLIO',
	'contacts/Why sponda/1/body': 'offers you new options that suit your needs flexibly as your space requirements change.',
	'contacts/Why sponda/2/title': 'FOCUSED ON PRIME LOCATIONS',
	'contacts/Why sponda/2/body': 'our property portfolio includes a variety of high-quality solutions for your company’s business premises needs.',
	'contacts/Why sponda/3/title': 'OUR COMPREHENSIVE ENVIRONMENTAL PROGRAMMES',
	'contacts/Why sponda/3/body': 'promote the joint development of the energy-efficiency and eco-friendliness of your business premises.',
	'contacts/Why sponda/4/title': 'VERSATILE, HIGH-QUALITY SERVICES',
	'contacts/Why sponda/4/body': 'facilitate your operations at our properties and support your business success.',
	'contacts/Why sponda/5/title': 'OUR EXPERIENCE AND PROFESSIONAL',
	'contacts/Why sponda/5/body': 'expertise help us identify your property needs and offer suitable premises that support your business operations.',

	'a11y/Accessibility': 'Accessibility',
	'a11y/Renovation year': 'Renovation year',
	'a11y/Energy efficiency class': 'Energy class',
	'a11y/Energy efficiency program': 'Energy efficiency program',
	'a11y/Environment certificate': 'Environment certificate',

	'responsibility/Page title': 'Sustainability',

	'app/Other language': 'fi',
	'app/Other language name': 'Suomeksi',
	'app/Loading': 'Loading...',
	'app/sort/abc': 'Alphabetical (Address)',
	'app/sort/abc_name': 'Alphabetical (Name)',
	'app/sort/abc_building_name': 'Alphabetical (Property name)',
	'app/sort/area': 'Area',

	'header/Back to browse': 'Back to browse',
	'header/Back to building': 'Back to property',

	'space-type/office': 'Office',
	'space-type/production': 'Production',
	'space-type/store': 'Store',
	'space-type/storage': 'Storage',
	'space-type/meeting': 'Meeting',
	'space-type/teach': 'Teach',
	'space-type/logistic': 'Logistic',

	'layout/fullPage': 'One image',
	'layout/halfAndHalf': 'Text and image',
	'layout/verticalLargeAndSmall': 'Horizontal image and text',
	'layout/horizontalSmallAndLarge': 'Vertical text and image',
	'layout/horizontalLargeAndSmall': 'Vertical image and text',
	'layout/LargeAndSmall': 'Large and small image',
	'layout/contacts': 'Contacts',
	'layout/contact': 'Contact (editable)',
	'layout/accessibility': 'Accessibility',
	'layout/responsibility': 'Sustainability',
	'layout/largeMap': 'Large map',
	'layout/building': 'Building',
	'layout/space': 'Space',
	'layout/spaceDetails': 'Space: Image and text on left',
	'layout/spaceDetails2': 'Space: Text and image on left',
	'layout/spaceDetails3': 'Space: Text and image below a larger image',

	'controls/type/image': 'Image',
	'controls/type/text': 'Text',
	'controls/type/pictogram': 'Pictogram',
	'controls/type/page': 'Page',
	'controls/type/contact': 'Contact',
	'controls/type/responsibility': 'Sustainability',

	'controls/settings': 'Settings',
	'controls/close': 'Close',
	'controls/cancel/Cancel selection': 'Cancel selection',
	'controls/cancel/Cancel changes': 'Cancel changes',
	'controls/save/Use selected images': 'Use selected images',
	'controls/save/Save changes': 'Save changes',
	'controls/common/settings/background color': 'Content area background color',
	'controls/common/settings/layout': 'Content area layout',
	'controls/type/map': 'Map',
	'controls/map/info/default': 'Map help',
	'controls/text/Save unsaved changes': 'Save unsaved changes?',
	'controls/text/settings/column count': 'Column count',
	'controls/text/settings/layout/default': 'Default',
	'controls/text/settings/layout/centered': 'Centered',
	'controls/text/settings/layout/top-centered': 'Centered to top',
	'controls/text/settings/layout/bottom-centered': 'Centered to bottom',
	'controls/text/settings/layout/left-centered': 'Centered to left',
	'controls/text/info/default': 'You can change the text styling by selecting text and clicking on a style.',
	'controls/text/content/label': 'Import from database',
	'controls/text/content/choose': 'Select',
	'controls/text/content/building': 'Building',
	'controls/text/content/space': 'Space',
	'controls/text/content/ingress': 'Ingress',
	'controls/text/content/description': 'Description',
	'controls/text/content/additional_info': 'Building additional info',
	'controls/text/content/environment_certificate_text': 'Environment certificate text',
	'controls/text/content/building_services_additional_info': 'Building services',
	'controls/text/content/building_service_parking_additional_info': 'Parking',
	'controls/text/content/local_services_additional_info': 'Local services',
	'controls/text/content/accessibility_additional_info': 'Accessibility',
	'controls/text/content/No space selected': 'No space selected for page',
	'controls/text/editor/Placeholder': 'You can enter text here...',
	'controls/text/format/block/label': 'Paragraph format',
	'controls/text/format/inline/label': 'Selection format',
	'controls/text/format/h1': 'Heading',
	'controls/text/format/h2': 'Lift',
	'controls/text/format/h3': 'Ingress',
	'controls/text/format/h4': 'Sub heading',
	'controls/text/format/bold': 'Bold',
	'controls/text/format/italic': 'Italic',
	'controls/text/format/body': 'Body text',
	'controls/pictogram/info/default': 'Pictogram component help',
	'controls/pictogram/title/label': 'Piktogram title',
	'controls/pictogram/value/label': 'Piktogram description',
	'controls/pictogram/select items': 'Select pictograms',
	'controls/image/info/default': 'You can position an image by selecting it first.',
	'controls/image/info/align': `Image position, scale and coverage might not always work well together.
		Check the results on the PDF and web brochure.`,
	'controls/image/info/select': 'You may select one or more images',
	'controls/image/language/label': 'Choose image visibility on language version',
	'controls/image/language/all': 'Show on all languages',
	'controls/image/info/maxlength': `

		PDF can only show four images on a single slot, but on the web brochure all of the images are visible.`,
	'controls/image/image/name': 'Name',
	'controls/image/image/description': 'Description',
	'controls/image/scale/label': 'Scale ({{scale}})',
	'controls/image/position/label': 'Align ({{x}} / {{y}})',
	'controls/image/size/label': 'Size',
	'controls/image/size/cover': 'Cover area',
	'controls/image/size/contain': 'Contain in area',
	'controls/image/tag/label': 'Illustration',
	'controls/image/tag/description': 'Show "Illustration" on image',
	'controls/image/tag/alternativeLabel': 'Alternative illustration text',
	'controls/image/remove': 'Remove',
	'controls/image/remove/confirm': 'Are you sure you want to remove this image? This action is irreversible.',
	'controls/image/select images': 'Select images',
	'controls/contact/choose': 'Choose contact person',

	'controls/listitem/empty': 'No selections',
	'controls/listitem/select': 'Select items',
	'controls/listitem/selected': '(%s% / %t% selected)',
	'controls/listitem/title': 'Choose items',
	'controls/listitem/cancel': 'Cancel',
	'controls/listitem/confirm': 'Use selected items',
	'controls/listitem/remove': 'Do you want to remove selected item?',
	'controls/listitem/no items': 'No items available',

	'controls/responsibility/items': 'Sustainability items',
	'controls/responsibility/logos': 'Certificates',
	'controls/responsibility/select items': 'Select items',
	'controls/responsibility/select logos': 'Select certificates',
	'controls/responsibility/select images': 'Select images',
	'controls/responsibility/column options': 'Column count',
	'controls/responsibility/sidebar options': 'Sidebar content',
	'controls/responsibility/sidebar text': 'Text',
	'controls/responsibility/sidebar image': 'Image',
	'controls/responsibility/sidebar none': 'Hide sidebar',

	'header/filters/Contact': 'Contact',
	'header/filters/City': 'City',
	'header/filters/SpaceType': 'Space type',
	'header/filters/Place': 'Place',
	'header/filters/Location': 'Location',
	'header/filters/Area': 'Area',
	'header/filters/Search placeholder': 'Search by building, address or contact',
	'header/user/Settings': 'Settings',
	'header/user/Log out': 'Log out',
	'header/brochure/Show pages': 'Show page list',
	'header/brochure/Page settings': 'Page settings',
	'header/brochure/Generate PDF': 'Generate PDF',
	'header/brochure/Web brochure': 'Web brochure',
	'header/brochure/Share brochure': 'Share brochure',

	'browse/Add brochures to collection': 'Add brochures to the collection',
	'browse/Loading brochures': 'Loading brochures...',
	'browse/No brochures': 'No brochures available',
	'browse/Loading buildings': 'Loading buildings...',
	'browse/Listing all buildings': 'Listing all buildings',
	'browse/Building count': '{{count}} building',
	'browse/Building count_plural': '{{count}} buildings',
	'browse/Only show buildings with free spaces': 'Only show buildings with free spaces',
	'browse/Only show free spaces': 'Only show free spaces',
	'browse/Building/Tile/Space count': '{{count}} space',
	'browse/Building/Tile/Space count_plural': '{{count}} spaces',
	'browse/Building/List/Spaces/Filtered spaces': '+{{count}} space that did not match filters',
	'browse/Building/List/Spaces/Filtered spaces_plural': '+{{count}} spaces that did not match filters',
	'browse/Building/List/Floors': 'Floors',
	'browse/Building/List/Area': 'Area',
	'browse/Building/List/Construction year': 'Construction year',
	'browse/Building/List/Space types': 'Space types',
	'browse/Building/List/Contact': 'Contact',
	'browse/Building/List/Contact_plural': 'Contacts',
	'browse/Building/List/Floor': 'Floor',
	'browse/Building/List/Space': 'Space',
	'browse/Building/List/Free': 'Available',
	'browse/Building/List/Yes': 'Yes',
	'browse/Building/List/No': 'No',

	'building/prompt/Brochure name': 'Brochure name:',
	'building/prompt/Brochure type': 'Brochure type:',
	'building/prompt/Brochure space': 'Brochure space:',
	'building/prompt/Clone name': 'Copy name:',
	'building/prompt/(Copy)': '(Copy)',
	'building/confirm/Delete': 'Are you sure you wish to remove this brochure?',
	'building/images/browse images': 'Browse property images',
	'building/images/filter': 'Filter images:',
	'building/images/Close images': 'Close images',
	'building/images/modal/title': 'Property images',
	'building/images/modal/close': 'Close',
	'building/images/print': 'Print',
	'building/spaces/Floor': 'Floor',
	'building/spaces/Space': 'Space',
	'building/spaces/Available': 'Available',
	'building/spaces/Area': 'Area',
	'building/spaces/Yes': 'Yes',
	'building/spaces/No': 'No',
	'building/spaces/indicative price': 'Indicative price per sqm',
	'building/details/Floors': 'Floors',
	'building/details/Area': 'Area',
	'building/details/Space types': 'Space types',
	'building/details/Contact': 'Contact',
	'building/details/Contact_plural': 'Contacts',
	'building/Brochures': 'Brochures',
	'building/Create new brochure': 'Create new brochure',
	'building/Brochures/Latest first': 'Latest first',
	'building/Brochures/Page': '{{count}} page',
	'building/Brochures/Page_plural': '{{count}} pages',
	'building/Brochures/Share': 'Share',
	'building/Brochures/Copy': 'Duplicate',
	'building/brochures/clone/title': 'Duplicate brochure',
	'building/Brochures/View': 'View web brochure',
	'building/Brochures/Remove': 'Remove',
	'building/Brochures/Modified': 'Modified',
	'building/Brochures/Created': 'Created',
	'building/Brochures/Select spaces': 'Select space pages to copy',
	'building/Brochures/Contacts': 'Contacts',

	'brochure/Confirm slot change with unsaved changes': 'Content slot has unsaved changes.\n\nUnsaved changes will be lost if you change the slot you are editing.\n\nDo you wish to continue without saving?',
	'brochure/Read only': 'Read only mode enabled. You do not have permissions to edit this brochure.',
	'brochure/Page list/Remove selected page': 'Remove selected page',
	'brochure/Page list/Remove selected page_plural': 'Remove selected pages ({{count}} pcs)',
	'brochure/Page list/Remove selected page/Confirm': 'Are you sure you want to remove the selected page?',
	'brochure/Page list/Remove selected page/Confirm_plural': 'Are you sure you want to remove the selected pages? ({{count}} pcs)',
	'brochure/Page list/Add new page': 'Add new page',
	'brochure/Page select/Choose template': 'Choose a template for the new page',
	'brochure/Page select/Close': 'Close',
	'brochure/Page select/Add page': 'Add page',
	'brochure/Controls/Page/Attached space': 'Space attached to page',
	'brochure/Controls/Page/Not selected': 'Not selected',
	'brochure/Controls/Page/Layout': 'Page layout',
	'brochure/Controls/Page/Default layout': 'Default',
	'brochure/Controls/Page/Building pattern': 'Show building pattern on page',
	'brochure/Controls/Page/Sponda logo': 'Show Sponda logo on page',
	'brochure/Controls/Page/slot type': 'You can change slot type by dragging a type from the sidebar on to the slot.',
	'brochure/Share/title': 'Share brochure',
	'brochure/Share/Web brochure/label': 'Online brochure',
	'brochure/Share/Web brochure/address': 'Online brochure address',
	'brochure/PDF/generate': 'Generate PDF',
	'brochure/PDF/generate/open': 'Open PDF',
	'brochure/PDF/generate/generated': 'PDF generated',
	'brochure/PDF/generate/modal/title': 'Generate PDF',
	'brochure/PDF/generate/modal/cancel': 'Cancel',
	'brochure/PDF/generate/modal/close': 'Close',
	'brochure/PDF/generate/modal/generate': 'Generate PDF',
	'brochure/PDF/generate/modal/generating': 'Generating PDF...',
	'brochure/PDF/generate/modal/quality': 'Image quality',
	'brochure/PDF/generate/modal/quality/original': 'Original image quality (Slow download)',
	'brochure/PDF/generate/modal/quality/large': 'Good image quality',
	'brochure/PDF/generate/modal/quality/small': 'Poor quality (Fast download)',
	'brochure/PDF/copy to clipboard': 'Copy PDF url to clipboard',
	'brochure/PDF/copied to clipboard': 'Osoite kopioitu leikepöydälle',
	'brochure/Type/master': 'Master brochure',
	'brochure/Type/default': 'Default brochure',
	'brochure/Type/normal': 'Normal brochure',
	'controls/page/remove page': 'Remove page',
	'controls/page/remove confirm': 'Are you sure you want to remove this page?\n\nThis action is irreversible.',

	'login/Log in': 'Log in',
	'login/Logging in': 'Logging in...',
	'login/username': 'Username',
	'login/username/placeholder': 'you@sponda.fi',
	'login/password': 'Password',
	'login/error': 'Invalid username or password!',
	'login/back to login': 'Back to login',
	'login/new password': 'Create new password',
	'login/Order new password': 'Order new password',
	'login/forgot password': 'Forgotten password',
	'login/Forgotten password': 'Forgotten password',
	'login/Request a new password': 'Request a new password',
	'login/Requesting a new password...': 'Requesting password change...',
	'login/Password link in email': 'A link for the password change has been sent to your email.',
	'login/Password changed successfully!': 'Password changed successfully!',
	'login/New password': 'Enter new password',
	'login/Set new password': 'Set new password',
	'login/Setting new password...': 'Setting new password...',
	'login/password indicator 0': ' ',
	'login/password indicator 1': 'Too weak',
	'login/password indicator 2': 'Moderate',
	'login/password indicator 3': 'Good',

}
